// import logo from './logo.svg';
import {Routes,Route, Navigate}from 'react-router-dom'
import './App.css';
import Header from './components/header/header'
import Menu from './components/menu/Menu'
import TongQuan from './components/tong-quan/TongQuan'
import KhuCongNghiep from './components/khu-cong-nghiep/KhuCongNghiep'
import DoanhNghiep from './components/doanh-nghiep/DoanhNghiep'
import DauTu from './components/dau-tu-invest/DauTu'
import DatDaiLand from './components/dat-dai-land/DatDaiLand'
import HaTang from './components/ha-tang/HaTang'
import MoiTruong from './components/moi-truong/MoiTruong'
import LaoDong from './components/lao-dong/LaoDong'
import DichVuCong from './components/dich-vu-cong/DichVuCong';
function App() {
  return (
    <div className="App">
          <div>
            <Header/>
          </div>


      <div className='row'>
        <div className='col-sm-2'>
          <Menu/>
        </div>
        <div className='col-sm-10'>
          <Routes >
           <Route path='/dashboard' element={<TongQuan/>}/>

           <Route path='/khu-cong-nghiep' element={<KhuCongNghiep/>}/>

            <Route path='/doanh-nghiep' element={<DoanhNghiep/>}/>

            <Route path='/dau-tu' element={<DauTu/>}/>

              <Route path='/dat-dai' element={<DatDaiLand/>}/>

               <Route path='/ha-tang' element={<HaTang/>}/>

               <Route path='/moi-truong' element={<MoiTruong/>}/>

                <Route path='/lao-dong' element={<LaoDong/>}/>

                <Route path='/dich-vu-cong' element={<DichVuCong/>}/>
          </Routes>
        

        </div>

      </div>
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
    </div>
  );
}

export default App;
